var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPollyCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#985AFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0172911,
    y: 0.0172911,
    width: 23.9654,
    height: 23.9654,
    rx: 11.9827,
    stroke: "white",
    strokeOpacity: 0.05,
    strokeWidth: 0.0345821
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1885 4.54841C11.634 5.32003 10.8223 6.62269 9.37548 7.458C7.92869 8.2933 6.3947 8.34492 5.9492 7.5733C5.50371 6.80169 6.31541 5.49902 7.7622 4.66372C9.20899 3.82841 10.743 3.77679 11.1885 4.54841Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14062 8.96838C6.03161 8.96838 6.7539 10.3227 6.7539 11.9933C6.7539 13.6639 6.03161 15.0182 5.14062 15.0182C4.24963 15.0182 3.52734 13.6639 3.52734 11.9933C3.52734 10.3227 4.24963 8.96838 5.14062 8.96838Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95211 16.4204C6.39761 15.6487 7.9316 15.7004 9.37839 16.5357C10.8252 17.371 11.6369 18.6736 11.1914 19.4452C10.7459 20.2169 9.2119 20.1652 7.76511 19.3299C6.31832 18.4946 5.50662 17.192 5.95211 16.4204Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8115 19.4436C12.366 18.6719 13.1777 17.3693 14.6245 16.534C16.0712 15.6987 17.6052 15.647 18.0507 16.4187C18.4962 17.1903 17.6845 18.493 16.2377 19.3283C14.7909 20.1636 13.2569 20.2152 12.8115 19.4436Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8593 15.0148C17.9683 15.0148 17.246 13.6605 17.246 11.9899C17.246 10.3193 17.9683 8.96502 18.8593 8.96502C19.7503 8.96502 20.4726 10.3193 20.4726 11.9899C20.4726 13.6605 19.7503 15.0148 18.8593 15.0148Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0478 7.55779C17.6023 8.32941 16.0683 8.27779 14.6215 7.44248C13.1748 6.60718 12.363 5.30451 12.8085 4.53289C13.254 3.76128 14.788 3.8129 16.2348 4.6482C17.6816 5.4835 18.4933 6.78617 18.0478 7.55779Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollyCoin);
export default __webpack_public_path__ + "static/media/pollyCoin.4790f6e7b4e38050b4cdcabea692194f.svg";
export { ForwardRef as ReactComponent };